import React, { useContext } from "react";
import Link from "../components/Link";
import { State } from "../context/State";

const lookup = {
  delete: "\u{274C}",
  copy: "\u{1F4CE}",
  planeTakeoff: "\u{1F6EB}",
  plane: "\u{2708}",
  rightArrow: "\u{27A1}",
  eye: "\u{1F61C}",
  winking: "\u{1F609}",
  smiling: "\u{1F604}",
  cool: "\u{1F60E}",
  monkey: "\u{1F648}",
  eyes: "\u{1F440}",
  pin: "\u{1F4CC}"
};

const descLookup = {
  delete: "Delete layer",
  copy: "Copy layer as GeoJSON",
  plane: "Go to layer",
  planeTakeoff: "Go to layer",
  rightArrow: "Open form",
  eye: "Hide layer",
  winking: "",
  smiling: "",
  cool: "",
  monkey: "Show layer",
  eyes: "Hide layer",
  pin: "Move map to browser determined location (3 zooms)"
};

export const Emoji = ({ name, onClick, className, isActive }) => {
  const { setDescription } = useContext(State);
  return (
    <Link
      className={`link-button ${className}`}
      onClick={onClick ? onClick.bind(this) : undefined}
      hoverDesc={descLookup[name] || ""}
      isActive={isActive}
    >
      {lookup[name] ? lookup[name] : name}
    </Link>
  );
};
